import { RadialLayout } from '@antv/layout/lib/layout/radial';

export default RadialLayout;
